/* eslint-disable @typescript-eslint/no-explicit-any */
import {jwtDecode} from 'jwt-decode';
import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {STORAGE_KEYS} from '@/constants';
import {
  AzureLoginDTO,
  ForgotPassDTO,
  GetProfileTenantDTO,
  HttpService,
  LoginDTO,
  LogoutDTO,
  ResetPassDTO,
  ResponseDTO,
  UserDTO,
} from '@/shared';

@Service()
export class AuthService {
  @observable
  user?: UserDTO;
  @observable
  httpService = Container.get(HttpService);
  resetToken?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  role: any;

  constructor() {
    const user = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    user && (this.user = JSON.parse(user));
  }
  handleInfoAuth(data: any) {
    return {
      id: data.id,
      exp: data?.exp,
      iat: data.iat,
      name: data.name,
      roleId: data.roleId,
      sub: data.sub,
      tenantId: data.tenantId,
      username: data.username,
    };
  }
  @action.bound
  setUser(user: Partial<UserDTO>) {
    if (this.user) {
      this.user = {...this.user, ...user};
      localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(this.user));
    }
  }

  @action.bound
  getUser() {
    return this.user;
  }
  @action.bound
  async signIn(loginDTO: LoginDTO): Promise<ResponseDTO> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {data, msgSts} = await this.httpService.request(loginDTO);

    try {
      if (data?.access_token) {
        localStorage.setItem(STORAGE_KEYS.USER_ACCESS_TOKEN, data.access_token);
      }

      const token = data?.access_token || '';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const decoded: any = jwtDecode(token);
      const userLocal = JSON.stringify(decoded);
      localStorage.setItem(STORAGE_KEYS.USER_INFO, userLocal);
      localStorage.setItem(STORAGE_KEYS.ROLE_ID, JSON.stringify(decoded.roleId));

      return {data, msgSts};
    } catch {
      return {data, msgSts};
    }
  }

  @action.bound
  async signInAzure(req: AzureLoginDTO): Promise<ResponseDTO> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {data, msgSts} = await this.httpService.request(req);

    try {
      if (data?.access_token) {
        localStorage.setItem(STORAGE_KEYS.USER_ACCESS_TOKEN, data.access_token);
      }

      const token = data?.access_token || '';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const decoded: any = jwtDecode(token);
      const userLocal = JSON.stringify(decoded);
      localStorage.setItem(STORAGE_KEYS.USER_INFO, userLocal);
      localStorage.setItem(STORAGE_KEYS.ROLE_ID, JSON.stringify(decoded.roleId));

      return {data, msgSts};
    } catch {
      return {data, msgSts};
    }
  }

  public async getProfile(profileDTO: GetProfileTenantDTO): Promise<any> {
    const data: any = await this.httpService.request(profileDTO);

    return data;
  }
  isSignedIn(): boolean {
    return localStorage.getItem(STORAGE_KEYS.USER_ACCESS_TOKEN) !== null;
  }

  public async getForgotPass(
    forgotPassDTO: ForgotPassDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(forgotPassDTO);
  }

  public async getResetPass(resetPassDTO: ResetPassDTO): Promise<ResponseDTO> {
    return this.httpService.request(resetPassDTO);
  }

  public async logOut(logoutDTO: LogoutDTO): Promise<ResponseDTO> {
    const data: any = this.httpService.request(logoutDTO);
    return data;
  }
}
